/**
 * Configuration for the document scanner. Licence eligibility rules are the
 * configuration's, never code (CLAUDE.md): the category check below reads the
 * booked category's rule as `GET /v1/categories/{id}/options` serves it
 * (`Eligibility.licence.acceptedCategories`, packages/db/src/configuration),
 * the same list the server applies at hand-over. The check only WARNS — it
 * never blocks the hand-over (Decision 5); the server's rule still decides.
 */

/** The feature flag's settings key. Default OFF; the scan button is hidden
 *  unless this is true. */
export const DOCUMENT_SCAN_FLAG = 'document_scan.enabled'

/**
 * The booked category's licence rule, as the configuration has it: the
 * categories (EU field 9) that permit it; `null` when the category needs no
 * licence at all (an e-bike, say). `undefined` means the rule is not known
 * here (not loaded, or no eligibility rules configured) and nothing is said.
 */
export type LicenceRule = { readonly acceptedCategories: readonly string[] } | null

export type CategoryCheck = 'ok' | 'mismatch' | 'unknown'

/**
 * Does any scanned licence category cover the booked vehicle?
 *  - 'ok'       at least one category matches (or the category needs no licence),
 *  - 'mismatch' the category needs a licence and none of the scanned ones cover it,
 *  - 'unknown'  the rule is not known here, or no categories were scanned.
 * The caller turns 'mismatch' into a warning the operator may override.
 */
export function checkCategory(
  scanned: readonly string[] | undefined,
  rule: LicenceRule | undefined,
): CategoryCheck {
  if (rule === undefined) return 'unknown'
  if (rule === null) return 'ok' // needs no licence
  if (!scanned || scanned.length === 0) return 'unknown'
  const held = new Set(scanned.map((c) => c.toUpperCase()))
  return rule.acceptedCategories.some((c) => held.has(c.toUpperCase())) ? 'ok' : 'mismatch'
}
